import React from 'react'
import error from '../../../assets/icons/icons-error.svg'
import Text from '../../text/Text'
import './ErrorModal.css'
import { labels } from '../../../labels'

export interface ILiquidateErrorProps {
    onClick: () => void
}

export default function LiquidateError(props: ILiquidateErrorProps) {
    return (
        <div>
            <div className={'centeredIcon'}>
                <img src={error} />
            </div>
            <div>
                <Text
                    label={labels.liquidateError}
                    fontSize={15}
                    fontWeight={500}
                    color="#565656"
                    textAlign="center"
                    marginTop={20}
                />
                <Text
                    label={labels.problemPersist}
                    fontSize={15}
                    fontWeight={500}
                    color="#565656"
                    textAlign="center"
                    marginBottom={20}
                />
            </div>
            <div className={'centered'} style={{ marginBottom: 30 }}>
                <button
                    className={`modalButtonBack sm13 successBC`}
                    onClick={props.onClick}
                    style={{ height: 36 }}
                    type="button"
                >
                    Continuar
                </button>
            </div>
        </div>
    )
}
